import {computed, onMounted} from "vue";

export default {
	name: "FontSelect",
	props: {
		fields: {
			type: Array,
		},
		selected: {
			type: Object,
		},
		selected_full: {
			type: Object,
		},
		assetPath: {
			type: String
		},
		shape: {
			type: String,
		},
		field: {
			type: Array,
		},
		prices: {
			type:Object
		}
	},

	setup(props, {emit}) {

		var pickOption = (field) => {
			emit('select', field);
		}

		var currency = computed(() => {
			var c = '$';
			if (window.nse_config.product_info.currency) {
				c = window.nse_config.product_info.currency;
			}
			return c;
		});

		const classImageWrap = (field) => {
			var className = !!props.shape ? props.shape : '';
			if (props.selected && props.selected.value === field.value) {
				className += " selected";
			}

			return className;
		}

		const priceFormatted = (field) => {
			if (!props.prices[field.name]) return "";

			if (field.name === 'size') {
				return props.prices[field.name][field.value]
			} else if (field.name === 'poster_frame' && field.value.toString() !== 'none') {
				var sizeCurrent = props.selected_full.poster_size;
				return props.prices[field.name][sizeCurrent.value];
			}
		}

		const showPrice = (field) => {
			return window.nse_config.fields_show_price.indexOf(field.name) >= 0;
		}

		const cssVars = (field) => `--font-style: ${field.family}`

		return {
			pickOption,
			showPrice,
			currency,
			classImageWrap,
			priceFormatted,
			cssVars
		}

	}
}
